import { Outlet } from 'react-router';

import { MobileNav } from '@/components/layout/mobile-nav';
import { Navbar } from '@/components/layout/navbar';
import { Sidebar } from '@/components/layout/sidebar';
import { Topbar } from '@/components/layout/topbar';
import { useUiStore } from '@/stores/ui.store';

/**
 * The persistent frame every authenticated page renders inside.
 *
 * The topbar spans the full width at the top and carries the branding and the
 * account menu, so the logo sits in the same place whichever navigation mode
 * is active. Below it the main navigation is either a sidebar down the left or
 * a navbar across the top; below `md` both defer to the same off-canvas menu.
 */
export function AppShell() {
  const navMode = useUiStore((state) => state.navMode);

  return (
    <div className="flex h-[100dvh] flex-col overflow-hidden bg-canvas">
      <a
        href="#main-content"
        className="sr-only-focusable absolute top-2 left-2 z-50 rounded-sm bg-primary px-3 py-1.5 text-xs text-primary-content"
      >
        Skip to content
      </a>

      <Topbar />

      {navMode === 'navbar' && <Navbar />}

      {/* `min-h-0` lets the main column scroll instead of stretching the shell. */}
      <div className="flex min-h-0 flex-1">
        {navMode === 'sidebar' && <Sidebar />}

        <main id="main-content" className="min-w-0 flex-1 overflow-y-auto p-2.5 sm:p-3">
          <Outlet />
        </main>
      </div>

      <MobileNav />
    </div>
  );
}
